import { StyleSheet } from "react-native";
import { COLORS } from "../../../config/colors";
import { verticalSize, height } from "../../../functions/responsive";
import { THEME_STYLES } from "../../../theme/constants/themeStyles";
import { APP_VARIANT } from "../../../config/setting";
import { AvailableAppVariants } from "../../../theme/enums";
import { THEME_COLORS } from "../../../theme/constants/themeColors";

export default StyleSheet.create({
  root: {
    height: height(100),
    flexDirection: "column",
    justifyContent: "space-between",
    position: "relative"
  },
  rowStyle: {
    flexDirection: "row",
    alignItems: "center"
  },
  btnCont: {
    backgroundColor: APP_VARIANT === AvailableAppVariants.TataMotorsLite ? THEME_COLORS.primaryColor : COLORS.whiteColor,
    borderRadius: THEME_STYLES.buttonStyle.borderRadius,
    alignItems: "center",
    paddingHorizontal: 8,
    paddingVertical: 12,
    borderWidth: 1,
    borderColor: COLORS.blackColor,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 1
  },
  bottomCont: {
    // width: "100%",
    borderTopEndRadius: 12,
    borderTopStartRadius: 12,
    backgroundColor: COLORS.skyBlue,
    marginTop: -15
    // position: 'absolute',
    // bottom: 0,
  },
  flashBtnCont: {
    padding: 8,
    paddingHorizontal: 16,
    position: "absolute",
    bottom: 140,
    alignSelf: "center",
    backgroundColor: COLORS.darkBlack,
    // borderWidth: 1,
    // borderColor: COLORS.whiteColor,
    borderRadius: 100,
    flexDirection: "row",
    alignItems: "center"
  }
});
